import {Account} from "../types.ts";

export const getUserNameInfo = (user: Account) => {
    const hasFirstName = typeof user['firstName'] !== 'undefined' && user['firstName'].toString().length > 0;
    const hasLastName = typeof user['lastName'] !== 'undefined' && user['lastName'].toString().length > 0;
    
    const firstName = hasFirstName ? user['firstName'] : user['emailAddress'];
    const lastName = hasLastName ? user['lastName'] : '';
    
    const fullName = [firstName, lastName].join(' ');
    const isNameComplete = hasFirstName && hasLastName;
    
    return {
        firstName,
        lastName,
        fullName,
        hasFirstName,
        hasLastName,
        isNameComplete
    };
};